import type { ReactNode } from 'react';

import { DateHeure } from '../../composants/communs.tsx';
import { Montant } from '../../composants/ui/index.ts';
import { libelleMode } from './modes.ts';
import type { DetailVente } from './types.ts';

/** Fil chronologique : création, chaque règlement, contrepassation éventuelle. */
export function Historique({ vente }: { vente: DetailVente }): ReactNode {
  return (
    <section aria-label="Historique" className="vente-section">
      <div className="vente-section__tete">
        <h2>Historique</h2>
      </div>
      <ol className="fiche-historique">
        <li>
          <span className="fiche-historique__puce" />
          <div>
            <div style={{ fontWeight: 600 }}>Vente créée</div>
            <div className="fiche-historique__sous">
              par {vente.vendeur} · <DateHeure valeur={vente.horodatage_serveur} />
            </div>
          </div>
        </li>
        {vente.paiements.map((paiement) => (
          <li key={paiement.id}>
            <span className="fiche-historique__puce fiche-historique__puce--reglement" />
            <div>
              <div style={{ fontWeight: 600 }}>
                Encaissement <Montant valeur={paiement.montant} /> — {libelleMode(paiement.mode)}
              </div>
              <div className="fiche-historique__sous">
                <DateHeure valeur={paiement.horodatage_local} />
              </div>
            </div>
          </li>
        ))}
        {vente.statut === 'CONTREPASSEE' && (
          <li>
            <span className="fiche-historique__puce fiche-historique__puce--contrepassation" />
            <div>
              <div style={{ fontWeight: 600 }}>Vente contrepassée</div>
              {vente.motif_contrepassation !== null && vente.motif_contrepassation !== undefined && (
                <div className="fiche-historique__sous">{vente.motif_contrepassation}</div>
              )}
            </div>
          </li>
        )}
      </ol>
    </section>
  );
}
